module.exports = __webpack_public_path__ + "c9315c47236667af242b25fbb9e91dd4.svg";